import React from "react";
import SolutionCard from "./ui/SolutionCard";

const SolutionsSection: React.FC = () => {
    return (
        <section className="px-4 bg-white">
            <div className="max-w-234.75 mx-auto">
                <div className="text-center max-w-160 mx-auto mb-10">
                    <h2 className="font-red-hat text-[40px] leading-13.25 font-light text-[#1B515E]">Nos solutions</h2>

                    <div className="space-y-5 sm:space-y-8 mt-6 sm:mt-10">
                        <p className="text-[14px] sm:text-[16px] leading-5 sm:leading-6.5 tracking-[0.2px] text-[#1D1D1D]">
                            C&apos;est pourquoi nous avons conçu une <strong>solution tout-en-un</strong>, pensée pour vous permettre
                            <br /><strong>de vous concentrer uniquement sur vos sessions de formation</strong>,<br />
                            pendant que nous gérons la partie marketing, visibilité et acquisition de prospects.
                        </p>
                        <p className="text-[14px] sm:text-[16px] leading-5 sm:leading-6.5 text-[#1D1D1D]">
                            Deux solutions simples pour développer votre activité :
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-20">
                    <SolutionCard
                        number="1"
                        title="Acheter des leads qualifiés à l'unité"
                        features={[
                            "Vous consultez notre base de prospects",
                            "Vous choisissez uniquement ceux qui correspondent à vos critères.",
                            "Vous payez à la demande, sans abonnement.",
                            "Chaque lead contient : domaine souhaité, localisation, financement, niveau, objectifs."
                        ]}
                        footer="Idéal si vous avez déjà un rythme d'activité et que vous souhaitez compléter ponctuellemennt vos sessions."
                    />
                    <SolutionCard
                        number="2"
                        title="Souscrire à un abonnement tout-en-un"
                        features={[
                            "Accès illimité à des leads filtrés automatiquement",
                            "CRM intégré",
                            "Documents Qualiopi prêts à signer",
                            "Aucun besoin de négocier ou filtrer vous-même"
                        ]}
                        footer="Idéal si vous souhaitez automatiser votre acquisition et professionnaliser votre activité."
                    />
                </div>
            </div>
        </section>
    );
};


export default SolutionsSection;
